/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

import * as Sentry from "@sentry/browser";
import { BrowserTracing } from "@sentry/tracing";

window.Sentry = Sentry;

Sentry.init({
    dsn: process.env.SENTRY_LARAVEL_DSN,
    integrations: [new BrowserTracing()],
    tracesSampleRate: parseFloat(process.env.SENTRY_TRACES_SAMPLE_RATE),
});

require('./bootstrap');

import Vue from 'vue';
import ApolloClient from 'apollo-client';
import { ApolloLink } from "apollo-link";
import { createHttpLink } from 'apollo-link-http'
import { InMemoryCache } from 'apollo-cache-inmemory'
import { setContext } from 'apollo-link-context';
import VueApollo from 'vue-apollo'
import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import addVeeValidateRules from "./addVeeValidateRules";
import InstantSearch from "vue-instantsearch";
import 'livewire-vue';


require("./new_theme/new_theme")

require("magnific-popup/dist/jquery.magnific-popup.min")

require('./scrolleffects');
require('./onhover_effects');

require('./custom');

require("./chat");

require("./multiple_item_carousel");

require('select2');
require('sal.js');
window.ClassicEditor = require('@ckeditor/ckeditor5-build-classic');
window.bsCustomFileInput = require('bs-custom-file-input');

require("flatpickr");

import smoothscroll from 'smoothscroll-polyfill';
smoothscroll.polyfill();

window.Vue = Vue;

Vue.use(VueApollo);
Vue.use(BootstrapVue);
Vue.use(IconsPlugin);
Vue.use(InstantSearch);

addVeeValidateRules();

// HTTP connection to the API
const httpLink = createHttpLink({
    // You should use an absolute URL here
    uri: '/graphql',
    credentials: 'same-origin',
    headers: {
        "X-CSRF-TOKEN": document.querySelector('meta[name="csrf-token"]').content,
    }
})

// Cache implementation
const cache = new InMemoryCache({ addTypename: false })

// Create the apollo client
const apolloClient = new ApolloClient({
    link: httpLink,
    credentials: 'same-origin',
    cache: cache,
})

const apolloProvider = new VueApollo({
    defaultClient: apolloClient,
})


//import Vue from 'vue/dist/vue.min.js'
//Vue.config.productionTip = false;
//Vue.config.devtools = true;
/**
 * The following block of code may be used to automatically register your
 * Vue components. It will recursively scan this directory for the Vue
 * components and automatically register them with their "basename".
 *
 * Eg. ./components/ExampleComponent.vue -> <example-component></example-component>
 */

const files = require.context('./', true, /\.vue$/i)
files.keys().map(key => Vue.component(key.split('/').pop().split('.')[0], files(key).default))

//Vue.component('chat-message', require('./components/ChatMessageComponent.vue').default);
//Vue.component('chat', require('./components/ChatComponent.vue').default);
//Vue.component('chat-input', require('./components/ChatInputComponent.vue').default);

/**
 * Next, we will create a fresh Vue application instance and attach it to
 * the page. Then, you may begin adding components to this application
 * or customize the JavaScript scaffolding to fit your unique needs.
 */

import { MediaLibraryAttachment } from "media-library-pro-vue2-attachment";
import { MediaLibraryCollection } from "media-library-pro-vue2-collection";
Vue.component('media-library-attachment', MediaLibraryAttachment);
Vue.component('media-library-collection', MediaLibraryCollection);

const app = new Vue({
    el: '#app',
    // inject apolloProvider here like vue-router or vuex
    apolloProvider,
});

import 'emoji-picker-element';
import { Picker } from 'emoji-picker-element';
window.Picker = Picker;
window.VueApp = app;

require('fslightbox');

require('./accordion');

document.addEventListener('DOMContentLoaded', function () {
    window.addEventListener('showSuccess', event => {
        toastr.success(event.detail.message);
    });

    window.addEventListener('showError', event => {
        toastr.error(event.detail.message);
    });
});
